module.exports = __webpack_public_path__ + "img/TEQ_logo.73eb61d8.svg";